

















import {
  Vue,
  Component,
  Watch,
  VModel,
  Prop,
  PropSync,
  Emit,
} from "vue-property-decorator";

@Component({
  components: {},
})
export default class FuzzySearch extends Vue {
  @VModel({ type: String }) model!: string;
  @Prop(String) propLabel!: string;
  @Prop(String) propHeight!: string;
  @PropSync("propEntries", { type: Array }) entries!: Array<any>;
  @PropSync("propItems", { type: Array }) items!: Array<any>;
  @PropSync("propIsLoading", { type: Boolean }) isLoading!: boolean;
  @PropSync("propSearch", { type: String }) search!: string;

  mounted() {
    this.clear();
    this.set();
  }

  private clear(): void {
    this.entries = [];
    this.items = [];
    this.isLoading = false;
    this.search = "";
  }

  private set(): void {
    if (this.model) {
      this.search = this.model;
    }
  }

  @Emit("updateItems")
  emitItems() {
    return;
  }

  @Emit("updateEntries")
  emitEntries(value: string) {
    return;
  }

  @Emit("updateSelect")
  emitSelect(search: string) {
    return;
  }

  @Watch("model")
  watchModel() {
    this.set();
  }

  @Watch("entries")
  watchEntries() {
    this.emitItems();
  }

  @Watch("search")
  watchSearch() {
    this.emitEntries(this.search);
  }
}
